import Image from "next/image";
import { addBasePathToStrapiMedia, formatStrapiEntity } from "@/utils/strapi";
import { StrapiEntity, StrapiImage } from "@/utils/strapi";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./PresentationBlock.module.scss";

export type PresentationBlockProps = {
  title: string;
  description: string;
  image: StrapiEntity<StrapiImage>;
};

export const PresentationBlock = ({
  title,
  description,
  image,
}: PresentationBlockProps) => {
  const strapiImage = formatStrapiEntity(image);

  return (
    <div className={styles.presentationBlock}>
      <div className={styles.mainPresentation}>
        <h1 className={styles.title}>{title}</h1>

        <div className={styles.proImages}>
          <div className={styles.proLogoContainer}></div>
          <div className={styles.proImageContainer}>
            <Image
              src={addBasePathToStrapiMedia(strapiImage)}
              objectFit="contain"
              objectPosition="center"
              alt={strapiImage.alternativeText ?? ""}
              layout="fill"
            />
          </div>
        </div>
        <div className={styles.presentation}>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={injectPurifiedHTML(
              removeEmptyRel(description)
            )}
          />
        </div>
      </div>
    </div>
  );
};
